var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMpg = function SvgMpg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.5 10.5 18 6h4.5zM4.5 13h13.6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 9,
    x: 2.1,
    y: 11,
    fill: "#1C7ABE",
    rx: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.394 13.5h1.043l1.101 2.688h.047L7.687 13.5H8.73v4h-.82v-2.604h-.034L6.841 17.48h-.558l-1.036-2.593h-.033V17.5h-.82zm5.198 4v-4h1.578q.455 0 .775.174.32.172.488.478.17.306.17.704t-.172.703q-.171.304-.498.474-.323.17-.785.17h-1.006v-.678h.87a.85.85 0 0 0 .402-.084.56.56 0 0 0 .238-.236.74.74 0 0 0 .08-.35.7.7 0 0 0-.08-.347.54.54 0 0 0-.238-.233.9.9 0 0 0-.406-.084h-.57V17.5zm6.378-2.707a.9.9 0 0 0-.115-.252.78.78 0 0 0-.424-.307 1 1 0 0 0-.299-.04.96.96 0 0 0-.539.152 1 1 0 0 0-.36.443 1.7 1.7 0 0 0-.128.707q0 .418.127.711a1 1 0 0 0 .359.447 1 1 0 0 0 .549.153q.287 0 .49-.102a.73.73 0 0 0 .313-.29.87.87 0 0 0 .109-.444l.172.025h-1.031v-.637h1.673v.504q0 .528-.222.907a1.5 1.5 0 0 1-.613.582q-.391.203-.895.203-.562 0-.988-.248a1.7 1.7 0 0 1-.664-.71q-.237-.46-.237-1.093 0-.486.14-.867.144-.383.4-.649.255-.266.595-.404a1.9 1.9 0 0 1 .736-.139q.34 0 .633.1.294.098.52.277.228.18.373.428.144.246.185.543z"
  })));
};
export default SvgMpg;